import React from "react";

export const itensSeusDireitos = [
    {
      question: "Direito de acesso",
      answers: [
        {
          text: `
          O direito de saber se temos algum dado pessoal seu e de
          acessar esses dados. Quando você fizer a solicitação,
          enviaremos, em até 15 (quinze) dias, um relatório de quais
          dos seus dados pessoais estão conosco. Mostraremos, ainda,
          a finalidade de utilização dos dados, como utilizamos e
          com quais empresas, órgãos e entidades compartilhamos. Se
          você já é nosso cliente, tenha acesso simplificado aos
          seus dados na Área do Cliente.
          `,
          type: "default",
        },
      ],
      showDefault: true,
    },
    {
      question: "Direito de correção",
      answers: [
        {
          text: `
          A qualquer momento você pode corrigir ou retificar os
                      dados pessoais que controlamos, caso estejam
                      desatualizados ou incompletos. Esse direito garante que
                      não utilizaremos dados pessoais equivocados seus para
                      fornecer nossos produtos e serviços ou qualquer outro
                      tratamento que realizemos.
          `,
          type: "default",
        },
      ],
      showDefault: true,
    },
    {
      question: "Direito de portabilidade",
      answers: [
        {
          text: `
          A Lei Geral de Proteção de Dados dá a você o direito de
                      levar seus dados pessoais para uso em outras empresas,
                      órgãos ou entidades. Após esse pedido, nós enviaremos um
                      arquivo padrão com os dados pessoais que foram fornecidos
                      por você ao longo do relacionamento com a gente.
          `,
          type: "default",
        },
      ],
      showDefault: true,
    },
    {
      question: "Direito de exclusão",
      answers: [
        {
          text: `
          Você pode pedir exclusão, bloqueio ou solicitar que seus
                      dados sejam mantidos anônimos.
          `,
          type: "default",
        },
        {
          text: `
          É importante ressaltar que, nos casos a seguir, não é
          possível realizar essa exclusão:
          `,
          type: "default",
        },
        {
          text: (<>
          <li>
          se você é nosso cliente ativo e é usuário de nossos
                      produtos ou serviços;
          </li>
          <li>se você tem uma ocorrência aberta em nossos serviços de
                      atendimento ao cliente;</li>
          <li>se há alguma dívida pendente;</li>
          <li>se estivermos usando seus dados para atender a normas de
                      órgãos reguladores e/ou a outras exigências legais.</li>
          
          </>)
          
          ,
          type: "default",
        },
        
        {
          text: `
          Nestes casos, prestaremos a você todos os esclarecimentos,
                      por meio de nossa equipe de Proteção de Dados Pessoais.
          `,
          type: "default",
        },
      ],
      showDefault: true,
    },
    {
      question: "Direito de oposição",
      answers: [
        {
          text: `
          Você pode se opor à forma como tratamos seus dados
                      pessoais, sejam os dados que tratamos com base em nosso
                      legítimo interesse ou qualquer outro tratamento, como
                      publicidade e ofertas e os seus meios de envio (e-mail,
                      telefone, SMS etc.).
          `,
          type: "default",
        },
      ],
      showDefault: true,
    },
  ];